import {
  Badge,
  Box,
  // Button,
  Container,
  Divider,
  Flex,
  HStack,
  Icon,
  Link,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import Logo from "./Logo";
import IconBox from "../pure/Icons/IconBox";
import { FaLinkedin, FaSpotify } from "react-icons/fa";
import Theme from "../../constants/Theme";
import { FaXTwitter } from "react-icons/fa6";
import FooterLink from "./FooterLink";
import AppStoreButton from "./AppStoreButton";
import PlayStoreButton from "./PlayStoreButton";

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="white"
      py={14}
      borderTop="1px solid"
      borderColor="gray.100"
      id="resources"
      width="100%"
      minHeight="100vh"
      display="flex"
      alignItems="center"
    >
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10} mb={10}>
          {/* Column 1: Company Info */}
          <Box>
            <VStack align="flex-start" spacing={5}>
              <Logo size="8xl" />
              <Text fontSize="sm" color="gray.500">
                Revolutionizing healthcare documentation with AI-driven
                solutions that prioritize patient care.
              </Text>
            </VStack>
          </Box>

          {/* Column 2: Product */}
          <Box>
            <Text fontWeight="bold" fontSize="md" mb={4} color="gray.700">
              Product
            </Text>
            <VStack align="flex-start" spacing={3}>
              <FooterLink label="AI Documentation" path="/ai-documentation" />
              <FooterLink
                label="Medical Transcription"
                path="/medical-transcription"
              />
              <FooterLink
                label="Clinical Summaries"
                path="/clinical-summaries"
              />
              <FooterLink
                label="Smart EHR Integration"
                path="/smart-ehr-integration"
              />
              <FooterLink label="Pricing" path="/pricing" />
              <FooterLink
                label="Healthcare Analytics"
                path="/healthcare-analytics"
              />
              {/* <Link color="gray.500" _hover={{ color: "teal.500" }}>
                <HStack>
                  <Text>Enterprise Solutions</Text>
                  <Badge colorScheme="blue" size="sm">
                    New
                  </Badge>
                </HStack>
              </Link> */}
            </VStack>
          </Box>

          {/* Column 3: Resources */}
          {/* <Box>
            <Text fontWeight="bold" fontSize="md" mb={4} color="gray.700">
              Resources
            </Text>
            <VStack align="flex-start" spacing={3}>
              <Link color="gray.500" _hover={{ color: "teal.500" }}>
                Documentation
              </Link>
              <Link color="gray.500" _hover={{ color: "teal.500" }}>
                Case Studies
              </Link>
              <Link color="gray.500" _hover={{ color: "teal.500" }}>
                Podcast
              </Link>
              <Link color="gray.500" _hover={{ color: "teal.500" }}>
                Research Papers
              </Link>
              <Link color="gray.500" _hover={{ color: "teal.500" }}>
                Blog
              </Link>
              <Link color="gray.500" _hover={{ color: "teal.500" }}>
                <HStack>
                  <Text>Clinical Webinars</Text>
                  <Badge colorScheme="orange" size="sm">
                    Live
                  </Badge>
                </HStack>
              </Link>
            </VStack>
          </Box> */}

          {/* Column 4: Company */}
          {/* <Box>
            <Text fontWeight="bold" fontSize="md" mb={4} color="gray.700">
              Company
            </Text>
            <VStack align="flex-start" spacing={3}>
              <FooterLink label="About Us" path="/about" />
              <FooterLink label="Contact" path="/contact" />
              <FooterLink label="Blog" path="/blog" />
              <FooterLink label="Careers" path="/careers" />
              <FooterLink label="Press" path="/press" />
              <FooterLink label="Partners" path="/partners" />
              <FooterLink label="Investors" path="/investors" />
            </VStack>
          </Box> */}

          {/* Column 5: Newsletter */}
          <Box>
            <Text fontWeight="bold" fontSize="md" mb={4} color="gray.700">
              Available on
            </Text>
            <VStack align="flex-start" spacing={4}>
              {/* <Text color="gray.500" fontSize="sm">
                Subscribe to our newsletter for the latest updates on AI
                healthcare innovation.
              </Text>
              <HStack w="100%">
                <Button
                  w="full"
                  colorScheme="teal"
                  variant="outline"
                  borderRadius="full"
                  size="md"
                  _hover={{
                    transform: "translateY(-2px)",
                    boxShadow: "sm",
                  }}
                >
                  Subscribe
                </Button>
              </HStack> */}
              <VStack align="flex-start" spacing={2} w="100%" gap={8}>
                {/* <Text color="gray.500" fontSize="xs">
                  Available on:
                </Text> */}
                <HStack spacing={3} w="100%">
                  <AppStoreButton />
                  <PlayStoreButton />
                </HStack>
                <HStack spacing={4}>
                  <Link
                    href="https://open.spotify.com/show/5b37r393SWE5inP1lOm7G7"
                    aria-label="Spotify"
                    _hover={{ transform: "translateY(-2px)" }}
                    transition="all 0.2s"
                  >
                    <IconBox
                      bg="green.50"
                      color="green.500"
                      h="36px"
                      w="36px"
                      borderRadius="full"
                    >
                      <FaSpotify size={Theme.SIZES.ICON_MEDIUM} />
                    </IconBox>
                  </Link>
                  <Link
                    href="https://x.com/QiQHealth"
                    aria-label="Twitter"
                    _hover={{ transform: "translateY(-2px)" }}
                    transition="all 0.2s"
                  >
                    <IconBox
                      bg="gray.100"
                      color="gray.700"
                      h="36px"
                      w="36px"
                      borderRadius="full"
                    >
                      <FaXTwitter size={Theme.SIZES.ICON_MEDIUM} />
                    </IconBox>
                  </Link>
                  <Link
                    href="https://www.linkedin.com/company/qiq-health/about"
                    aria-label="LinkedIn"
                    _hover={{ transform: "translateY(-2px)" }}
                    transition="all 0.2s"
                  >
                    <IconBox
                      bg="blue.50"
                      color="blue.500"
                      h="36px"
                      w="36px"
                      borderRadius="full"
                    >
                      <Icon as={FaLinkedin} size={Theme.SIZES.ICON_MEDIUM} />
                    </IconBox>
                  </Link>
                </HStack>
                <HStack>
                  <Badge colorScheme="blue" px={2} py={1} borderRadius="md">
                    HIPAA
                  </Badge>
                  <Badge colorScheme="green" px={2} py={1} borderRadius="md">
                    GDPR
                  </Badge>
                  <Badge colorScheme="purple" px={2} py={1} borderRadius="md">
                    SOC 2
                  </Badge>
                </HStack>
              </VStack>
            </VStack>
          </Box>
        </SimpleGrid>

        <Divider mb={8} />

        <Flex
          width="100%"
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align={{ base: "center", md: "center" }}
          gap={{ base: 6, md: 0 }}
        >
          <HStack
            spacing={6}
            flexWrap="wrap"
            justify={{ base: "center", md: "flex-start" }}
          >
            <FooterLink
              label="Terms of Use"
              path="/terms"
              fontSize="sm"
              fontWeight="medium"
            />
            <FooterLink
              label="Privacy & Security"
              path="/privacy"
              fontSize="sm"
              fontWeight="medium"
            />

            <FooterLink
              label="Compliance"
              path="/compliance"
              fontSize="sm"
              fontWeight="medium"
            />
            <FooterLink
              label="Accessibility"
              path="/accessibility"
              fontSize="sm"
              fontWeight="medium"
            />
            <Link
              href="https://blog.weqiq.com"
              fontSize="sm"
              fontWeight="medium"
              color="gray.500"
              _hover={{ color: "teal.500" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Blog
            </Link>
          </HStack>
          <Text
            fontSize="sm"
            color="gray.500"
            textAlign={{ base: "center", md: "right" }}
          >
            © {new Date().getFullYear()} QIQ Health by WeFrequentists LLP. All
            rights reserved.
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
